/**
 * LoginEmail — email-input + Continue submit row.
 *
 * Native `<button>` only — the legacy button retired per
 * `the no-legacy-components rule`. Styling lives in
 * `style/modals/_magic-login-modal.scss` under
 * `.login-page_content_continue-button`.
 */

import {
    ChangeEventHandler,
    FormEvent,
    ReactElement,
    useState,
} from "react";
import { validateEmail } from "@/utils/validateEmail";

interface Props {
    initialEmail?: string;
    onSubmit: (email: string, useMagicLink: boolean) => void;
}

function LoginEmail(props: Props): ReactElement {
    const [email, setEmail] = useState<string>(props.initialEmail || "");

    const emailOnChange: ChangeEventHandler<HTMLInputElement> = (e) => {
        setEmail(e.target.value);
    };

    function loginWithEmail(e: FormEvent<HTMLFormElement>): void {
        e.preventDefault();
        props.onSubmit(email, false);
    }

    return (
        <form onSubmit={loginWithEmail}>
            <div className="login-page_content_email-container">
                <label>Email</label>
                <input
                    type="email"
                    required
                    placeholder="Enter your email address"
                    value={email}
                    onChange={emailOnChange}
                />
            </div>

            <button
                type="submit"
                className="login-page_content_continue-button"
                disabled={!validateEmail(email)}
            >
                Continue
            </button>
        </form>
    );
}

export default LoginEmail;
